import { render, staticRenderFns } from "./tabTitle.vue?vue&type=template&id=3eba550b&scoped=true"
import script from "./tabTitle.vue?vue&type=script&lang=js"
export * from "./tabTitle.vue?vue&type=script&lang=js"
import style0 from "./tabTitle.vue?vue&type=style&index=0&id=3eba550b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eba550b",
  null
  
)

export default component.exports